import {Role} from "../mixins/AuthMixin"

export default function (data = {}) {
  return [
    {
      title: "Vue d'ensemble",
      to: {name: "dashboard"},
      htmlBefore: "<i class=\"material-icons\">bar_chart</i>",
      htmlAfter: "",
      roles: [Role.CONTROLLER, Role.ADMIN, Role.SUPER_ADMIN],
    },
    {
      title: "Comptes",
      to: "",
      htmlBefore: "<i class=\"material-icons\">person</i>",
      htmlAfter: "",
      roles: [Role.HELP_DESK, Role.OP_MANAGER, Role.ADMIN, Role.SUPER_ADMIN],
      items: [
        {
          title: "Tous les comptes",
          to: {name: "accounts.users"},
        },
        {
          title: "Créer un compte",
          to: {name: "accounts.create"},
        },
        {
          title: "Exporter",
          to: {name: "accounts.export"},
        },
      ]
    },
    {
      title: "Transactions",
      to: "",
      htmlBefore: "<i class=\"material-icons\">swap_horiz</i>",
      htmlAfter: "",
      roles: [Role.CONTROLLER, Role.HELP_DESK, Role.OP_MANAGER, Role.ADMIN, Role.SUPER_ADMIN],
      items: [
        {
          title: "Transactions",
          to: {name: "transactions.list"},
        },
        {
          title: "Transactions CAMPOST",
          to: {name: "transactions.campost"},
        },
        {
          title: "Paiements de masse",
          to: {name: "transactions.bulk_payments"},
        },
        {
          title: "Virements manuels",
          to: {name: "transactions.bank_transfers.manual"},
        },
        {
          title: "Virements auto",
          to: {name: "transactions.bank_transfers.auto"},
        },
        {
          title: "Recharges",
          to: {name: "transactions.top_ups"},
        }
      ]
    },
    {
      title: "Trésor Pay",
      to: "",
      htmlBefore: "<i class=\"material-icons\">swap_horiz</i>",
      htmlAfter: "",
      roles: [Role.TRESORPAY_MANAGER, Role.OP_MANAGER, Role.ADMIN, Role.SUPER_ADMIN],
      items: [
        {
          title: "Virements",
          to: {name: "tresorpay.payments"},
        },
      ]
    },
    {
      title: "Incidents",
      to: {name: "issues"},
      htmlBefore: "<i class=\"material-icons\">report</i>",
      htmlAfter: data.issuesCount
        ? `<span class="badge badge-pill badge-outline-danger ml-3">${data.issuesCount}</span>`
        : "",
      roles: [Role.CONTROLLER, Role.HELP_DESK, Role.OP_MANAGER, Role.ADMIN, Role.SUPER_ADMIN],
    },
    {
      title: "Marchands",
      to: "",
      htmlBefore: "<i class=\"material-icons\">store</i>",
      htmlAfter: "",
      roles: [Role.CONTROLLER, Role.HELP_DESK, Role.OP_MANAGER, Role.ADMIN, Role.SUPER_ADMIN],
      items: [
        {
          title: "Services marchands",
          to: {name: "merchants.services"}
        },
        {
          title: "Comptes bancaires",
          to: {name: "merchants.bank_accounts"},
        },
      ]
    },
    {
      title: "Tableaux de contrôle",
      to: "",
      htmlBefore: "<i class=\"material-icons\">find_in_page</i>",
      htmlAfter: "",
      roles: [Role.ADMIN, Role.SUPER_ADMIN],
      items: [
        {
          title: "Services",
          to: {name: "inconsistency.services"},
        },
      ]
    },
    {
      title: "Paramètres",
      to: "",
      htmlBefore: "<i class=\"material-icons\">settings</i>",
      htmlAfter: "",
      roles: [Role.ADMIN, Role.SUPER_ADMIN],
      items: [
        {
          title: "Opérateurs",
          to: {name: "settings.operators"},
        },
        {
          title: "Gateways",
          to: {name: "settings.gateways"},
        },
        {
          title: "Banques",
          to: {name: "settings.banks"},
        },
        {
          title: "Devises",
          to: {name: "settings.currencies"},
        },
        {
          title: "Rôles",
          to: {name: "settings.roles"},
        },
        {
          title: "Droits des services",
          to: {name: "settings.rights"},
        },
      ]
    },
  ]
}
